export const state = {
  cancelTokens: [],
}

export const getters = {
  cancelTokens(state) {
    return state.cancelTokens
  },
}

export const mutations = {
  ADD_CANCEL_TOKEN(state, token) {
    state.cancelTokens.push(token)
  },
  CLEAR_CANCEL_TOKENS(state) {
    state.cancelTokens = []
  },
}

export const actions = {
  cancelPendingRequests({ commit, state, rootState }) {
    state.cancelTokens.forEach((request, i) => {
      if (request.cancel) {
        request.cancel()
      }
      commit('CLEAR_CANCEL_TOKENS')
    })
  },
}
